import * as LucideIcons from 'lucide-react'
import type { LucideProps } from 'lucide-react'

interface LucideTabIconProps extends LucideProps {
  icon: string
}

/**
 * Renders a Lucide icon by name. Falls back to the default custom-field tab icon
 * (SlidersHorizontal) if the name isn't a Lucide export.
 */
export function LucideTabIcon({ icon, ...props }: LucideTabIconProps) {
  const Icon = (LucideIcons as any)[icon] as React.FC<LucideProps> | undefined
  const Fallback = LucideIcons.SlidersHorizontal
  const Component = Icon ?? Fallback
  return <Component {...props} />
}
